import {
  type UseQueryOptions,
  type UseQueryReturnType,
  useQuery,
} from '@tanstack/vue-query'
import type { MaybeRef } from '@vueuse/core'
import { TanStackQueryIds } from './query-ids'
import { getListItems } from '~~/src/api/lists'
import type { Elemental } from '~~/src/types/elemental'
import type { GetReturn } from '~~/src/types/utils'

type FnArgs = Parameters<typeof getListItems>

export const useListElementalsQuery = (
  args: {
    id?: MaybeRef<FnArgs[0] | null | undefined>
    query?: FnArgs[1]
    isAdmin?: boolean
  },
  options?: Omit<
    UseQueryOptions<
      GetReturn<typeof getListItems<Elemental>>,
      Error
    >,
    'queryKey' | 'queryFn' | 'placeholderData' | 'keepPreviousData'
  >,
): UseQueryReturnType<GetReturn<typeof getListItems<Elemental>>, Error> => {
  return useQuery({
    queryKey: [TanStackQueryIds.LIST_ELEMENTALS, args.id, args.query, args.isAdmin] as const,
    queryFn: async ({ queryKey, signal }) => {
      const [_, id, query, isAdmin] = queryKey
      if (!id)
        throw new Error('id is required')

      return getListItems<Elemental>(id, query, signal, isAdmin)
    },
    ...options,
  })
}
